import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_URL


export const getTopicsBySubject = async (subject) => {
  try {
    const response = await axios.get(`${BASE_URL}pyqs/topics/${subject}`, {
      headers: {
        Accept: 'application/json',
      },
    });
    return response.data;
  } catch (error) {
    console.error(`Error fetching topics for ${subject}:`, error);
    throw error;
  }
};

export const getSubjectsMains = async () => {
  const accessToken = localStorage.getItem('access_token');
  if (!accessToken) {
    return Promise.reject("Unauthorized");
  }

  try {
    const response = await axios.get(`${BASE_URL}mains-practice/subjects`, {
      headers: {
        accept: 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching subjects:', error);
    return Promise.reject(error);
  }
};


export const getQuestionsBySubjectMainsPractice = async (subject, limit = 5) => {
  const accessToken = localStorage.getItem('access_token');
  if (!accessToken) {
    return Promise.reject("Unauthorized");
  }

  try {
    const response = await axios.get(`${BASE_URL}mains-practice/questions`, {
      headers: {
        accept: 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
      params: {
        subject,
        limit,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching questions:', error);
    return Promise.reject(error);
  }
};